import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp12};
  padding: ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: ${props => props.theme.primitives.radius.radius1};
`

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp8};
`

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const ChipsRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  flex-wrap: wrap;
`
